module.exports = __webpack_public_path__ + "img/fairplay-book-desktop.3c25ea0.jpg";